import { showOverlayConstants } from '../constants';

const show = (overlayName: string, props = {}) => {
  return {
    type: showOverlayConstants.SHOW_OVERLAY,
    payload: { overlayName, props },
  };
};

const close = (overlayName: string) => {
  return {
    type: showOverlayConstants.CLOSE_OVERLAY,
    payload: { overlayName },
  };
};

const closeAll = () => {
  return {
    type: showOverlayConstants.CLOSE_ALL_OVERLAY,
  };
};

export const showOverlayActions = {
  show,
  close,
  closeAll,
};
